<template>
  <div class="truckContent">
    <div class="advancedSearch">
      <div class="searchContent">
        <div class="searchTime">
          <div class="startTime">开始时间</div>
          <div class="middle">至</div>
          <div class="endTime">结束时间</div>
        </div>
        <div class="searchVehicle">
          车牌号
          <span class="vehicleNo">陕A12345</span>
        </div>
      </div>
      <div class="searchBtn">开始搜索</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchTime",
  props: ['svalue','placeholder'],
  data() {
    return {
    };
  },
  methods: {

  },

  watch: {}
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SearchBar/SearchTime.vue